import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CartService from "../../services/CartService";
import {
	addToCart,
	decreaseProduct,
	increaseProduct,
} from "../../store/actions/AuthActions";
import "./style.css";
import { motion } from "framer-motion";
import logoImg from "../../assets/logo.svg";

const ProductCard = ({ product, hasAddToCart }) => {
	const [showNumbers, setShowNumbers] = useState(false);
	const [amount, setAmount] = useState(1);
	const { t } = useTranslation();
	const lang = useSelector((state) => state?.lang?.lang);
	const user = useSelector((state) => state?.user);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const cartService = new CartService();

	const addCart = (type, amountData) => {
		if (!!user?.user) {
			if (type === "INCREASEFirst") {
				let data = {
					products: [
						{
							dynamic_variant: [],
							amount: 1,
							product_id: product?.id,
						},
					],
				};
				cartService
					.create(data)
					.then((res) => {
						if (res?.status === 201) {
							toast.success(t("Product Added To Cart"));
							dispatch(increaseProduct(product));
							setShowNumbers(true);
						}
					})
					.catch((e) => {
						if (
							e.response?.data?.message ===
							"product_is_already_Exist_in_your_cart"
						) {
							let data = {
								product_id: product.id,
								amount: 1,
							};
							cartService.update(data).then((res) => {
								if (res?.status === 200) {
									toast.success(t("Product Added To Cart"));
								}
							});
							return;
						}
						toast.error(e.response?.data?.message?.replaceAll("_", " "));
					});
			} else {
				let data = {
					product_id: product.id,
					amount: amountData,
				};
				cartService.update(data).then((res) => {
					if (res?.status === 200) {
						if (type === "INCREASE") {
							dispatch(increaseProduct(product?.product));
						} else {
							dispatch(decreaseProduct(product?.product));
						}
					}
				});
			}
		} else {
			let data = {
				...product,
				dynamic_variant: [],
				amount: 1,
				in_stock: product.amount,
				product_id: product?.id,
			};
			if (type === "INCREASEFirst") {
				toast.success(t("Product Added To Cart"));
				dispatch(addToCart(data));
			} else if (type === "INCREASE") {
				dispatch(increaseProduct(data));
			} else {
				dispatch(decreaseProduct(data));
			}
			setShowNumbers(true);
		}
	};

	return (
		<div
			className="product-card"
			data-aos="flip-left"
			data-aos-easing="ease-out-cubic"
			data-aos-duration="800">
			<div className="product-image">
				<motion.img
					src={product.product_images[0]?.url || logoImg}
					className="w-100 h-100"
					alt="product"
					whileHover={{ scale: 1.1 }}
					whileTap={{ scale: 0.95 }}
					transition={{ type: "spring", stiffness: 200 }}
				/>
			</div>
			<div className="details">
				<div>
					<h6
						className="text-ellipsis"
						onClick={() =>
							navigate(`/products/product/${product?.id}`, {
								state: { product },
							})
						}>
						{lang === "en" ? product.name_en : product.name_ar}
					</h6>
					<motion.h6
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ delay: 0.25, duration: 1 }}
						className="mb-3">
						{(product.offer ? product.offerPrice : product?.price)?.toFixed(3)}{" "}
						{t("KWD")}
					</motion.h6>
				</div>
				<div>
					{!showNumbers && hasAddToCart && product?.amount > 0 && (
						<button
							onClick={() => addCart("INCREASEFirst")}
							className="btn add-cart btn-block">
							{t("Add To Cart")}
						</button>
					)}
					{showNumbers && (
						<div className="add-to-cart-buttons">
							<button
								disabled={amount === product?.amount}
								onClick={() => {
									addCart("INCREASE", amount + 1);
									setAmount((prev) => prev + 1);
								}}
								className="minus">
								<svg
									width="24"
									height="25"
									viewBox="0 0 24 25"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M6 12.5H18"
										stroke="white"
										strokeWidth="2.4"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M12 18.5V6.5"
										stroke="white"
										strokeWidth="2.4"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</button>
							<span>{amount}</span>
							<button
								disabled={amount === 0}
								onClick={() => {
									if (amount === 1) {
										setShowNumbers(false);
									} else {
										addCart("DECREASE", amount - 1);
									}
									setAmount((prev) => prev - 1);
								}}
								className="minus">
								<svg
									width="22"
									height="3"
									viewBox="0 0 22 3"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M1.39941 1.5H20.5994"
										stroke="white"
										strokeWidth="2.4"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</button>
						</div>
					)}
					{product?.amount === 0 && (
						<p className="text-danger text-center">{t("out of stock")}</p>
					)}
				</div>
			</div>
		</div>
	);
};
export default ProductCard;
